export const displayMode = (): 'standalone' | 'browser' => {
  const standAlone = '(display-mode: standalone)';

  return (navigator as unknown as { standalone: boolean }).standalone ||
    window.matchMedia(standAlone).matches
    ? 'standalone'
    : 'browser';
};
